import React from "react";
import image from "./location.svg";
import { FormattedMessage } from "react-intl";
import { useBrowserGPS } from "../../../mapUi/mapUi.component.jsx";
import {
  BottomButtonContainer,
  BottomButton,
} from "../../../elements/wrapper/bottomButton.wrapper.jsx";
import { getQueryParams } from "../../../../app/RouteWithSubRoutes";
import StandardHeadline from "../../../elements/text/standardHeadline.text.jsx";
import LoadingIcon from "../../../elements/loading/spinner.component.jsx";
import IntroImage from "../../introImage.component.jsx";
import StandardInstruction from "../../../elements/text/standardInstruction.component.jsx";
import ToggleSetting from "../../../elements/buttons/toggleSetting.component.jsx";
import { isIOS } from "react-device-detect";
import { useNativePermissionCheck } from "../../../nativeAppInterface/sideEffects/useNativePermissionCheck.js";
import { pageNames } from "../../../../reduxStore/reducers/main";
import { MODULES } from "../../../../reduxStore/actions/main";
import { HowToActivateLocation } from "../../../settings/pages/Location";

/**
 * Die LocationAbfrage im Intro
 * @param userAllowedGPS
 * @param setUserAllowedGPS
 * @param locationPermissionAllowed
 * @param setGPSData
 * @param history
 * @param setLocationPermissionAllowed
 * @param isApp
 * @param match
 * @return {JSX.Element}
 * @constructor
 */
export default function Location({
  userAllowedGPS,
  setUserAllowedGPS,
  locationPermissionAllowed,
  setGPSData,
  history,
  setLocationPermissionAllowed,
  isApp,
  setProperties,
  addToast = () => {},
  locationObject,
  isTerminal,
}) {
  const handleClick = () => {
    if (userAllowedGPS === null) {
      setUserAllowedGPS(false);
    }

    if (isApp && isIOS && userAllowedGPS && MODULES.hatNavigationIndoorLive) {
      // iOS User können zusätzliche Gyrofunktionen des Geräts nutzen
      history.push(
        `/${pageNames.intro}/${pageNames.selectHealthstats}/${getQueryParams()}`
      );
    } else {
      history.push(
        `/${pageNames.intro}/${
          pageNames.selectRestrictions
        }/${getQueryParams()}`
      );
    }
  };
  const handleToggle = () => {
    setProperties({
      location: { userAllowed: !userAllowedGPS },
    });
  };
  const handleBack = () => {
    history.goBack();
  };

  useBrowserGPS(
    setLocationPermissionAllowed,
    setGPSData,
    setUserAllowedGPS,
    addToast,
    isApp,
    userAllowedGPS,
    setProperties,
    isTerminal,
    locationObject
  );

  const native = useNativePermissionCheck(
    userAllowedGPS,
    locationPermissionAllowed,
    true
  );

  return (
    <BottomButtonContainer
      buttons={[
        new BottomButton(
          handleBack,
          <FormattedMessage id={"search.buttonBack"} />,
          { className: "mr-3 normalButton--naked", disabled: native.waiting }
        ),
        new BottomButton(handleClick, <FormattedMessage id="welcome.next" />, {
          disabled: native.waiting,
          loading: true,
          className: "normalButton--primary",
        }),
      ]}
    >
      <IntroImage fallbackImage={image} imageName={"location.svg"} />
      <div className="pl-3 pr-3">
        <StandardHeadline className={"mb-2 mt-3"} type={"h2"}>
          <FormattedMessage id="welcome.locationTitle" />
        </StandardHeadline>
        <StandardInstruction className={"mb-4"} type={"p"}>
          <FormattedMessage id="welcome.locationText" />
        </StandardInstruction>
        <div className="d-flex justify-content-between pl-3 pr-3 w-100">
          <ToggleSetting
            toggleValue={!!userAllowedGPS}
            onChange={handleToggle}
            settingText={<FormattedMessage id="welcome.locationToggleText" />}
          />
        </div>
        {native.denial && (
          <div>
            <p className="mb-3">
              <FormattedMessage id="welcome.allowedButNoPermission" />
              <FormattedMessage id="welcome.allowedButNoPermission.appendix" />
            </p>
            <HowToActivateLocation denial={native.denial} isApp={isApp} />
          </div>
        )}

        <LoadingIcon
          icon={"map-marker-alt"}
          loading={native.waiting}
          pulse={true}
          mode={"opacity"}
          fullscreen={false}
        />
      </div>
    </BottomButtonContainer>
  );
}
